window.HMAPSocialReferralNotificationsSettingsForm = function ($scope, $alert, settingsFactory, brand) {
    var self = this;
    var formName = "hmap-social-referral-notifications-settings-form";
    var _protected = BaseForm.call(self, formName, $scope);


    self.data = {};
    self.originalSettings = {};
    self.isSaving = false;
    self.employees = {};

    self.loading = true;

    self.brandId = brand.id;


    self.load = function () {
        var results = {};
        results["socialReferralNotificationsSettings"] = NotificationCenterAPIV2.loadSocialReferralNotificationsSettings(self.brandId);
        results["employees"] = UserAPI.getEmployees(self.brandId);


        $q.all(results)
            .then(function(res){

                self.data = res.socialReferralNotificationsSettings;
                if(!self.data.employment_period_settings || !self.data.employment_period_settings.length){
                    self.data.employment_period_settings.push({
                        id: null,
                        period: null,
                        period_unit: null
                    });
                }
                self.employees = res.employees.users;

                self.originalSettings = angular.copy(res.socialReferralNotificationsSettings);

                if (self.data.users) {
                    for (var j = 0; j < self.data.users.length; j++) {
                        self.data.users[j].full_name = self.data.users[j].first_name + ' ' + self.data.users[j].last_name;
                    }
                }

                for (var i = 0; i < self.employees.length; i++) {
                    self.employees[i].full_name = self.employees[i].first_name + ' ' + self.employees[i].last_name;
                }

                self.loading = false;

            }, function (err) {
                console.error(err);
            });

    };

    self.onNotificationsToggleChanged = function () {

        self.data.users = [];
        self.data.employment_period_settings.length = 0;
        self.data.employment_period_settings.push({
            id: null,
            period: null,
            period_unit: null
        });
    };

    self.addNewPeriod = function () {
        if (self.data.enabled) {
            self.data.employment_period_settings.push({
                id: null,
                period: null,
                period_unit: null
            });
        }
    };

    self.deletePeriod = function (index) {
        if (self.data.enabled) {
            self.data.employment_period_settings.splice(index, 1);
            if (!Object.keys(self.data.employment_period_settings).length) {
                self.validator.validation = {};
                self.addNewPeriod();
            }
        }
    };

    self.save = function () {
        var defer = $q.defer();

        self.validator.validate(function (isValid) {
            if (isValid) {
                var params = {}
                if (!self.data.enabled) {
                    params['enabled'] = false;
                } else {
                    params = angular.copy(self.data);
                }

                NotificationCenterAPIV2.updateSocialReferralNotificationsSettings(self.brandId, params)
                    .then(function (result) {
                        HNotifications.show({
                            title: $filter("translate")("Success"),
                            desc: $filter("translate")("Saved successfully") + "!",
                            icon: "fa-check-circle",
                            type: "success"
                        });
                        defer.resolve();
                    }).catch(function (err) {
                    HNotifications.show({
                        title: $filter("translate")("Error"),
                        desc: $filter("translate")("Something went wrong!"),
                        icon: "fa-times-circle",
                        type: "danger"
                    });
                    defer.reject();
                });
            } else {
                HNotifications.show({
                    title: $filter("translate")("Error"),
                    desc: $filter("translate")("Something went wrong!"),
                    icon: "fa-times-circle",
                    type: "danger"
                });
                defer.reject();

            }
        });
        return defer.promise;
    };

    self.discard = function () {
        self.data = angular.copy(self.originalSettings);
    };


};
